<div class="venue-selector" [class.open]="isOpen">
  <!-- Single venue: nothing to choose between, so show a static label. -->
  <div *ngIf="isSingleVenue" class="venue-selector__static form-control">
    <span class="venue-selector__label">{{ selectedVenueName }}</span>
  </div>

  <!-- Trigger: shows the current selection and toggles the panel -->
  <button
    *ngIf="!isSingleVenue"
    type="button"
    class="venue-selector__trigger form-control"
    (click)="toggleOpen()"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
  >
    <span class="venue-selector__label">{{ selectedVenueName }}</span>
    <span class="venue-selector__caret" aria-hidden="true"></span>
  </button>

  <div class="venue-selector__panel" *ngIf="isOpen && !isSingleVenue" role="listbox">
    <input
      #search
      type="text"
      class="venue-selector__search form-control"
      placeholder="Search venues…"
      [(ngModel)]="searchTerm"
      autocomplete="off"
    />

    <div class="venue-selector__scroll">
      <!-- Pinned "Scanning now" group -->
      <ng-container *ngIf="activeVenues.length && cityHasMatches(activeVenues)">
        <div class="venue-group venue-group--active">
          <div class="venue-group__header venue-group__header--active">
            <span class="venue-group__dot" aria-hidden="true"></span>
            <span class="venue-group__title">Scanning now</span>
            <span class="venue-group__count">{{ filterVenues(activeVenues).length }}</span>
          </div>
          <button
            type="button"
            class="venue-option"
            *ngFor="let venue of filterVenues(activeVenues); trackBy: trackByVenue"
            [class.selected]="venue.key === selectedKey"
            (click)="selectVenue(venue.key)"
            role="option"
            [attr.aria-selected]="venue.key === selectedKey"
          >
            {{ venue.value.name }}
          </button>
        </div>
      </ng-container>

      <!-- Continent -> city -> venue hierarchy -->
      <ng-container *ngFor="let continent of tree; trackBy: trackByContinent">
        <div class="venue-group" *ngIf="continentHasMatches(continent)">
          <button
            type="button"
            class="venue-group__header"
            (click)="toggleGroup('continent:' + continent.continent)"
          >
            <span
              class="venue-group__chevron"
              [class.expanded]="isExpanded('continent:' + continent.continent) || searchTerm"
              aria-hidden="true"
            ></span>
            <span class="venue-group__title">{{ continent.continent }}</span>
            <span
              class="venue-group__dot"
              *ngIf="isContinentActive(continent.continent)"
              title="Scanning now"
              aria-label="Scanning now"
            ></span>
          </button>

          <div
            class="venue-group__body"
            *ngIf="isExpanded('continent:' + continent.continent) || searchTerm"
          >
            <ng-container *ngFor="let city of continent.cities; trackBy: trackByCity">
              <div class="venue-subgroup" *ngIf="cityHasMatches(city.venues)">
                <button
                  type="button"
                  class="venue-subgroup__header"
                  (click)="toggleGroup(cityId(continent.continent, city.city))"
                >
                  <span
                    class="venue-group__chevron"
                    [class.expanded]="
                      isExpanded(cityId(continent.continent, city.city)) || searchTerm
                    "
                    aria-hidden="true"
                  ></span>
                  <span class="venue-subgroup__title">{{ city.city }}</span>
                  <span
                    class="venue-group__dot"
                    *ngIf="isCityActive(continent.continent, city.city)"
                    title="Scanning now"
                    aria-label="Scanning now"
                  ></span>
                </button>

                <div
                  class="venue-subgroup__body"
                  *ngIf="
                    isExpanded(cityId(continent.continent, city.city)) || searchTerm
                  "
                >
                  <button
                    type="button"
                    class="venue-option"
                    *ngFor="let venue of filterVenues(city.venues); trackBy: trackByVenue"
                    [class.selected]="venue.key === selectedKey"
                    (click)="selectVenue(venue.key)"
                    role="option"
                    [attr.aria-selected]="venue.key === selectedKey"
                  >
                    <span class="venue-option__name">{{ venue.value.name }}</span>
                    <span
                      class="venue-group__dot"
                      *ngIf="isVenueActive(venue.key)"
                      title="Scanning now"
                      aria-label="Scanning now"
                    ></span>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div class="venue-selector__empty" *ngIf="!venues.length">No venues available.</div>
    </div>
  </div>
</div>
